module.exports = __webpack_public_path__ + "static/media/arlet-pulse.02d774ab.mp4";